export const projectsData = [
  {
    name: "Codenames",
    url: "jacardiovascular.webp",
    description:
      "A multiplayer game built with React, TypeScript, and Mantine UI ",
    webaddress: "https://github.com/allwinp/jacardiovascular",
  },
  {
    name: "AImages",
    url: "AImages.webp",
    description:
      "Full MERN stack application using OpenAI's DALL-E to create and share AI generated images",
    webaddress: "https://aimages.vercel.app",
  },
  {
    name: "Online Portfolio",
    url: "portfolio.webp",
    description: "You're currently on it",
    webaddress: "https://github.com/allwinp/allwin-portfolio",
  },
];
